import { styled, css } from "styled-components";
import { InputWrapper } from "@template/components/Input/styles.ts";

export const CartDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  gap: 8px;

  ${({ theme }) => theme.breakpoints.md.query} {
    padding: 0;
  }
`;

export const BasketTitle = styled.h3`
  font-size: 32px;
  margin-bottom: 2rem;

  ${({ theme }) => theme.breakpoints.md.query} {
    margin-bottom: 1rem;
  }
`;

export const CartFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 19px;
  font-weight: 700;
  line-height: 78%;
  color: ${({ theme }) => theme.colors.default[900]};
  &:first-of-type {
    border-top: 1px solid ${({ theme }) => theme.colors.default[200]};
    padding-top: 24px;
  }
`;

export const TotalLabel = styled.p``;

export const TotalValue = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    color: ${({ theme }) => theme.colors.default[500]};
    margin-left: 4px;
  }
`;

export const StartContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const FooterButton = styled.div`
  align-self: flex-end;
`;

export const CartItemsWrapper = styled.div<{ $advanced?: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: auto;

  ${({ $advanced }) =>
    $advanced
      ? css``
      : css`
          max-height: 300px;
        `}
`;

export const CartItemContainer = styled.div`
  color: ${({ theme }) => theme.colors.default[400]};
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  font-size: 14px;
  gap: 12px;
  position: relative;
  align-items: center;
`;

export const InlineContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const ExtrasContainer = styled.div`
  width: 100%;
  gap: 24px;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  ${({ theme }) => theme.breakpoints.sm.query} {
    display: flex;
    flex-direction: column;
  }
`;

export const CartItemLabel = styled.p`
  font-weight: 600;
  display: flex;
  height: fit-content;
  align-items: center;
  gap: 2px;

  & svg {
    color: ${({ theme }) => theme.colors.default[300]};
  }

  & > button {
    &:hover {
      & svg {
        color: revert;
      }
    }
  }

  > span {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-start;
  width: 100%;
  ${({ theme }) => theme.breakpoints.sm.query} {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const CenterContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex: none;
    justify-content: flex-start;
  }
`;

export const RightContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex: none;
    justify-content: flex-end;
  }
`;

export const RightRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  ${({ theme }) => theme.breakpoints.sm.query} {
    flex: 1;
    gap: 16px;
    width: auto;
  }
`;

export const CartItemPrice = styled.div`
  display: flex;
  font-weight: 900;
  align-content: flex-end;
`;

export const CartItemPriceStrike = styled(CartItemPrice)`
  text-decoration: line-through;
  opacity: 0.4;
  font-weight: 500;
`;

export const ItemType = styled.div`
  justify-self: flex-start;
  margin-right: auto;
  font-weight: 700;
  font-size: 19px;
  color: ${({ theme }) => theme.colors.default[900]};
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  & svg {
    color: ${({ theme }) => theme.colors.default[600]};
  }

  & > button {
    &:hover {
      & svg {
        color: revert;
      }
    }
  }
`;

export const CartItemWrapper = styled.div<{
  $advanced?: boolean;
  $isPlan?: boolean;
}>`
  overflow-x: clip;
  overflow-y: visible;
  ${({ $advanced, theme, $isPlan }) =>
    $advanced &&
    css`
      &:not(:last-of-type) {
        border-bottom: 1px solid ${theme.colors.default[100]};
      }

      ${CartItemPrice} {
        margin-left: auto;
      }

      ${InlineContainer} {
        flex-direction: column;
        gap: 2px;
        align-items: flex-start;
      }

      ${ItemType} {
        ${theme.breakpoints.sm.query} {
          align-items: flex-start;
          flex-wrap: ${$isPlan ? "wrap" : "inherit"};

          ${InputWrapper} {
            align-self: flex-start;
            margin-left: 0 !important;
          }

          ${CartItemPrice} {
            align-self: center;
          }
        }
        ${theme.breakpoints.xs.query} {
          ${InputWrapper} {
            flex-basis: 100%;
            justify-content: flex-start;
            > * {
              width: fit-content;
              margin-left: revert !important;
            }
          }
        }
      }
    `}
`;

export const Help = styled.span`
  width: 16px;
  height: 16px;

  > svg {
    width: 16px;
    height: 16px;
    color: ${({ theme }) => theme.colors.default[400]};
  }
`;

// export const PlanContainer=styled.div`
//   display: grid;
//   height: 100%;
//   width: 100%;
//   color: black;
//   background-color: #F6F5F5;
//   padding: 20px;
//   gap: 24px;
// `;

// export const PlanWrapper=styled.div<{$isAddOn?:boolean}>`
//   display:flex;
//   flex-direction:row;
//   gap: 6px;
//   justify-content: ${({$isAddOn})=>$isAddOn ?"flex-start" :"space-around"}
// `;

export const PlanContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.default[50]};
  padding: 18px;
  border-radius: 12px;
  width: 100%;
  max-width: 650px;
`;

export const PlanSection = styled.div`
  margin-bottom: 0px;
`;

export const PlanLabel = styled.label`
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.default.default};
`;

export const PlanRadioGroup = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 8px;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
  }
`;

export const PlanRadioLabel = styled.label`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.default[500]};
  gap: 4px;

  span {
    color: ${({ theme }) => theme.colors.default.default};
    font-weight: 550;
  }
`;

export const PlanRadio = styled.input`
  appearance: none;
  border: 1px solid ${({ theme }) => theme.colors.primary.default};
  border-radius: 50%;
  width: 16px;
  height: 16px;
  position: relative;
  cursor: pointer;
  aspect-ratio: 1 / 1;
  margin-top: 0;

  &:checked::before {
    content: "";
    position: absolute;
    background: ${({ theme }) => theme.colors.primary.default};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -47%);
  }

  &:not(:checked) {
    border: 1px solid ${({ theme }) => theme.colors.default[300]};
    background: ${({ theme }) => theme.colors.primary[0]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PlanCheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;

  span {
    color: ${({ theme }) => theme.colors.default.default};
    font-weight: 550;
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.default[500]};
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-wrap: wrap;
    gap: 4px;

    p {
      width: 100%;
      text-align: right;
      margin-top: 4px; /* optional: add some spacing */
    }

    span {
      width: 26vh;
    }
  }
`;

export const PlanCheckbox = styled.input`
  appearance: none;
  border: 1px solid ${({ theme }) => theme.colors.primary.default};
  border-radius: 4px;
  width: 16px;
  height: 16px;
  position: relative;
  cursor: pointer;
  background: ${({ theme }) => theme.colors.default[0]};

  &:checked::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 1px;
    width: 4px;
    height: 8px;
    border: 1px solid ${({ theme }) => theme.colors.primary.default};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.default[100]};
    border: 1px solid ${({ theme }) => theme.colors.default[300]};
  }

  &:disabled:checked::after {
    border-color: ${({ theme }) => theme.colors.default[300]};
  }
`;

export const PlanRenewText = styled.div`
  display: flex;
  font-size: 16px;
  gap: 4px;

  span {
    color: ${({ theme }) => theme.colors.default.default};
    font-weight: 550;
  }
`;

export const PlanHighlightDate = styled.span`
  color: ${({ theme }) => theme.colors.default[500]} !important;
  font-weight: 500;
`;
